export default __webpack_public_path__ + "static/media/261.91e26be9.png";